
/**
  ブランクページ（初期表示用）
*/
<template>
  <v-ons-page>
    <div class="content">
      <!--
    <h3>伝票照会に失敗しました。</h3>
    <p>ShopCode:{{ShopCode}}</p>
    <p>ShopIP:{{ShopIP}}</p>
    <p>ApiVersion:{{ApiVersion}}</p>
    <p>PortNo:{{PortNo}}</p>
    <p>SlipNo:{{SlipNo}}</p>
    <p>SlipDate:{{SlipDate}}</p>
    -->
    </div>
  </v-ons-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'blank',
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'ShopCode',
      'ShopIP',
      'ApiVersion',
      'PortNo',
      'SlipNo',
      'SlipDate',
      ]),
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";
.content{
  padding: 10px 10px 30px;
  background-color: #222!important;
  color: $base-font-color;
}
/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/NotfoundPage.vue